module.exports = __webpack_public_path__ + "resources/5468da4923feaec4fc813c0cd23d8d89.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/backgroundsupermove5.png
// module id = 199
// module chunks = 0